import type { ShoppingWalletActivityItem } from '@/presentation/stores/ShoppingWalletStore';

interface WalletCreditTermsProps {
  item: ShoppingWalletActivityItem;
}

function categoryLabel(item: ShoppingWalletActivityItem): string {
  const ids = item.eligibleProductCategoryIds;
  if (!ids?.length) return '';
  const names = ids.map((id) => item.eligibleProductCategories?.find((category) => category.id === id)?.name.trim());
  if (names.some((name) => !name)) return 'Selected categories';
  return [...new Set(names)].join(' & ');
}

export function getWalletCreditTerms(item: ShoppingWalletActivityItem) {
  const conditions = [
    item.redemptionScope === 'NEW_PURCHASES' ? 'New purchases only' : '',
    categoryLabel(item),
  ].filter(Boolean).join(' · ');
  const minimum = Number(item.minimumPurchaseAmount);
  return { conditions, minimum: Number.isFinite(minimum) && minimum > 0 ? minimum : null };
}

export function WalletCreditTerms({ item }: WalletCreditTermsProps) {
  const { conditions, minimum } = getWalletCreditTerms(item);
  if (!conditions && minimum === null) return null;

  return (
    <div className={conditions ? 'space-y-0.5 border-t border-[#EEEEEE] pt-2.5 text-[12px] leading-relaxed' : 'text-[12px]'}>
      {conditions ? <p className="break-words font-medium text-[#555555]">{conditions}</p> : null}
      {minimum !== null ? (
        <p className="text-[#777777]">Use on items priced {item.currency} {minimum.toLocaleString('en-GH', { maximumFractionDigits: 2 })} or more</p>
      ) : null}
    </div>
  );
}
